import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/Header/index.tsx";
import Sidebar from "../../components/Sidebar/index.tsx";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import { useVersionCheck } from "../../hooks/useVersionCheck.ts";
import { useSyncThemeAttribute } from "../../hooks/useSyncThemeAttribute.ts";
import "../../styles/design-system.css";

const MainLayout = ({ children }) => {
  const location = useLocation();
  const { showFeedback } = useFeedback();

  const { updateAvailable, applyUpdate } = useVersionCheck();
  useSyncThemeAttribute();

  const isLoginPage = location.pathname === "/";
  const isSetupPage = location.pathname === "/setup";
  const isBareLayout = isLoginPage || isSetupPage;

  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebar_collapsed") === "1");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("sidebar_collapsed", collapsed ? "1" : "0");
  }, [collapsed]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const blockedMsg = localStorage.getItem("subscription_blocked");
    if (blockedMsg) {
      showFeedback(blockedMsg, "error");
      localStorage.removeItem("subscription_blocked");
    }

    const updatedMsg = localStorage.getItem("app_updated_message");
    if (updatedMsg) {
      showFeedback(updatedMsg, "success");
      localStorage.removeItem("app_updated_message");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isBareLayout) {
    return <div className="ds">{children}</div>;
  }

  return (
    <div className={`ds ds-app ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}>
      <button
        type="button"
        className="ds-mobile-backdrop"
        onClick={() => setMobileOpen(false)}
        aria-label="Fechar menu"
        tabIndex={mobileOpen ? 0 : -1}
      />
      <Sidebar
        collapsed={collapsed}
        onToggleCollapsed={() => setCollapsed((prev) => !prev)}
        onNavigate={() => setMobileOpen(false)}
      />
      <div className="ds-main">
        <Header toggleMenu={() => setMobileOpen((prev) => !prev)} />
        {updateAvailable && (
          <div className="ds-update-banner">
            <span>Uma nova versão do sistema está disponível.</span>
            <div className="ds-update-banner-actions">
              <button type="button" className="ds-update-banner-btn" onClick={applyUpdate}>
                Atualizar agora
              </button>
            </div>
          </div>
        )}
        <main className="ds-content">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
